// extracted by mini-css-extract-plugin
export default {"lineWrapper":"Sign_lineWrapper__JH7jl"};